<router-outlet />
<app-assistant-launcher />
<app-command-palette />
<app-onboarding-tour />
